// A notification email as it will arrive: the shared layout (the same code the worker sends with) filled
// with sample data and the template being edited, in a sandboxed frame. The frame allows no scripts; it
// is same-origin only so its height can be read and the whole email shown without a scrollbar.
import { useMemo, useRef, useState } from 'react';
import { EMAIL_LOGO_PNG_B64, NOTIFY_SAMPLE_VARS, buildNotifyEmail, renderEmailHtml, type NotifyEvent } from '@technohull/shared';

const LOGO = `data:image/png;base64,${EMAIL_LOGO_PNG_B64}`;

export function EmailPreview({ event, subject, body }: { event: NotifyEvent; subject: string; body: string }) {
  const mail = useMemo(
    () => buildNotifyEmail(event, NOTIFY_SAMPLE_VARS, { custom: { subject, body }, appUrl: window.location.origin }),
    [event, subject, body],
  );
  // no web-font link inside the app (its own fonts and CSP); the sent email carries one
  const html = useMemo(() => renderEmailHtml(mail, LOGO, { webFonts: false }), [mail]);
  const frame = useRef<HTMLIFrameElement>(null);
  const [height, setHeight] = useState(560);
  const fit = () => {
    const doc = frame.current?.contentDocument;
    if (doc?.body) setHeight(Math.max(320, doc.documentElement.scrollHeight));
  };
  return (
    <div className="email-preview">
      <div className="email-preview-hd">
        <span className="email-preview-subj"><span className="muted">Subject:</span> {mail.subject}</span>
        <span className="muted email-preview-note">Sample data</span>
      </div>
      <iframe
        ref={frame}
        title={`Preview: ${mail.subject}`}
        sandbox="allow-same-origin"
        srcDoc={html}
        onLoad={fit}
        style={{ height }}
      />
    </div>
  );
}
